import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Axios";
import { IndividualProgressTable } from "../../components/IndividualProgressTable/IndividualProgressTable.jsx";
import { IndividualProgressWidgets } from "../../components/IndividualProgressWidgets/IndividualProgressWidgets.jsx";
import useAuth from "../../contexts/UserContext.tsx";
import { selectCourseName } from "../../features/student/studentSlice.js";
import "react-circular-progressbar/dist/styles.css";
import { toast } from "sonner";

export const IndividualStudentProgress = () => {
  const courseName = useSelector(selectCourseName);

  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { id, course_id, name } = useParams();

  const [individualData, setIndividualData] = useState();
  const [exerciseDetailsArray, setExerciseDetailsArray] = useState();

  const getIndividualStudentProgress = async () => {
    try {
      const res = await axiosInstance.post("/getStudentProgress", {
        auth_token: user.auth_token,
        crs_id: course_id,
        student_id: id,
        student_name: name,
      });
      if (res.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      setIndividualData(res.data.data.student_excs_details);
      convertObjectToArray(res.data.data.student_excs_details.excs_details);
    } catch (err) {
      console.error(err.message);
    }
  };

  const convertObjectToArray = (data) => {
    const newArray = Object.keys(data).map((key) => ({
      id: key,
      ...data[key],
    }));
    setExerciseDetailsArray(newArray);
  };

  useEffect(() => {
    getIndividualStudentProgress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="individual-student-progress-container p-3">
      {individualData && (
        <>
          <div className="individual-student-progress-header grid grid-cols-5">
            <div className="individual-student-progress-header-left col-span-4 p-1 flex flex-col justify-between">
              <div className="flex gap-[23vw]">
                <ArrowBackIcon
                  className="back-btn hover:cursor-pointer"
                  onClick={() => navigate(-1)}
                />
                <div className="flex flex-col items-center">
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    {name}
                  </Typography>
                  <Typography variant="h6" className="text-gray-500">
                    {courseName}
                  </Typography>
                </div>
              </div>
              <div className="mr-4">
                <IndividualProgressWidgets schoolData={individualData} />
              </div>
            </div>
            <div className="individual-student-progress-header-right rounded-md flex flex-col justify-center items-center shadow-xl p-4">
              <div className="h-40 w-40 text-center mb-2">
                <CircularProgressbar
                  value={individualData.percentage_complete}
                  text={`${individualData.percentage_complete}%`}
                />
              </div>
              <Typography variant="h6" className="text-gray-500">
                Overall Progress
              </Typography>
            </div>
          </div>
          <div className="individual-student-progress-body mt-4">
            <IndividualProgressTable
              student_id={id}
              data={exerciseDetailsArray}
            />
          </div>
        </>
      )}
    </div>
  );
};
